const o = "_accordion_1eqlm_1", c = "_accordion__item_1eqlm_8", _ = "_accordion__button_1eqlm_20", n = "_accordion__content_1eqlm_25", t = {
  accordion: o,
  accordion__item: c,
  accordion__button: _,
  accordion__content: n
};
export {
  o as accordion,
  _ as accordion__button,
  n as accordion__content,
  c as accordion__item,
  t as default
};
